import { combineReducers } from 'redux';
import * as t from '../actions/types';
import { handleAction, handleActions } from 'redux-actions';
import { data as initialDataState } from '../store/initialState';
// ---
// Higher-order reducers.
// ---
const isFetchingReducer = (types, defaultState = null) => {
  const [REQUEST, SUCCESS, FAILURE] = types;

  const reducerMap = {
    [REQUEST]: () => 'fetching',
    [SUCCESS]: () => 'success',
    [FAILURE]: () => 'error',
  };

  return handleActions(reducerMap, defaultState);
};

// TODO: Check for message or whatever
const errorReducer = actionTypes => {
  if (!Array.isArray(actionTypes)) {
    throw new Error('Action Types should be an array.');
  }

  const [SET, RESET] = actionTypes;

  let reducerMap = {
    [SET]: (state, { payload }) =>
      payload && payload.message
        ? payload.message
        : 'Etwas ist schief gelaufen.',
  };

  // TODO: Is this dangerous mutation?
  if (RESET) {
    reducerMap[RESET] = () => null;
  }

  return handleActions(reducerMap, null);
};

// TODO: refactor into one key-reducer
const keyedFetchReducer = ({ types, mapActionToKey }) => {
  const fetchReducer = isFetchingReducer(types, {});

  return (state = {}, action) => {
    const key = mapActionToKey(action.payload || action);
    if (!key) return state;
    const keyedState = state[key];
    return { ...state, [key]: fetchReducer(keyedState, action) };
  };
};

const keyedErrorReducer = ({ type, mapActionToKey }) => {
  const reducer = errorReducer(type);
  return (state = {}, action) => {
    const key = mapActionToKey(action.payload || action);
    if (!key) return state;
    const keyedState = state[key];
    return { ...state, [key]: reducer(keyedState, action) };
  };
};

// ---
// Slice reducer.
// ---

const order = handleActions(
  {
    [t.SET_PAYMENT_METHOD]: (state, { payload }) => ({
      ...state,
      paymentMethod: payload.method,
    }),
    [t.SET_ACTIVE_ORDER]: (state, action) => ({
      ...state,
      activeOrder: { ...action.payload },
    }),
    [t.UPDATE_ACTIVE_ORDER]: (state, action) => ({
      ...state,
      activeOrder: { ...action.payload },
    }),
    [t.CLEAR_ACTIVE_ORDER]: state => ({
      ...state,
      activeOrder: null,
    }),
    [t.SET_ORDER_WIZARD_VALUES]: (state, action) => ({
      ...state,
      orderForm: { ...action.payload },
    }),
    [t.FLUSH_ORDER]: state => ({
      ...state,
      ...{
        paymentMethod: null,
        activeOrder: null,
        orderForm: null,
      },
    }),
  },
  {
    ...initialDataState.order,
  }
);

const profile = handleAction(
  t.SET_CURRENT_PROFILE,
  (state, action) => ({
    ...state,
    ...action.payload,
  }),
  initialDataState.profile
);

const user = handleActions(
  {
    [t.SET_CURRENT_USER]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    [t.CLEAR_CURRENT_USER]: () => ({}),
  },
  initialDataState.user
);

const cart = handleAction(
  [t.SET_CART],
  (state, { payload }) => ({
    ...state,
    ...payload,
  }),
  initialDataState.cart
);

const ui = handleActions(
  {
    [t.TOGGLE_NAV]: state => ({
      ...state,
      showNav: !state.showNav,
    }),
    [t.TOGGLE_FILTER]: state => ({
      ...state,
      showFilter: !state.showFilter,
    }),
    [t.TOGGLE_CART]: state => ({
      ...state,
      showCart: !state.showCart,
    }),
    [t.TOGGLE_ORDER_SUMMARY]: state => ({
      ...state,
      showOrderSummary: !state.showOrderSummary,
    }),
    [t.TOGGLE_PRICES]: state => ({
      ...state,
      showPrices: !state.showPrices,
    }),
    [t.TOGGLE_ARTICLE_DETAIL]: (state, { payload }) => ({
      ...state,
      showDetail: !state.showDetail,
      activeItem: state.showDetail ? null : payload,
    }),
  },
  {
    ...initialDataState.ui,
  }
);

const rootReducer = combineReducers({
  error: combineReducers({
    auth: errorReducer([t.AUTHENTICATION_REQUEST_FAILURE]),
    cart: errorReducer([t.CART_REQUEST_FAILURE]),
    profile: errorReducer([t.PROFILE_REQUEST_FAILURE]),
    createSource: errorReducer([t.CREATE_STRIPE_SOURCE_FAILURE]),
    createOrder: errorReducer([t.CREATE_ORDER_FAILURE]),
    payOrder: errorReducer([t.PAY_ORDER_FAILURE]),
    fetchOrder: errorReducer([t.ORDER_STATUS_FAILURE]),
    cartItems: keyedErrorReducer({
      type: [t.UPDATE_CART_ITEM_FAILURE, t.RESET_CART_ITEM_ERROR],
      mapActionToKey: ({ articleID }) => articleID,
    }),
  }),
  status: combineReducers({
    auth: isFetchingReducer([
      t.AUTHENTICATION_REQUEST,
      t.AUTHENTICATION_REQUEST_SUCCESS,
      t.AUTHENTICATION_REQUEST_FAILURE,
    ]),
    logout: isFetchingReducer([
      t.LOGOUT_REQUEST,
      t.LOGOUT_REQUEST_SUCCESS,
      t.LOGOUT_REQUEST_FAILURE,
    ]),
    cart: isFetchingReducer([
      t.CART_REQUEST,
      t.CART_REQUEST_SUCCESS,
      t.CART_REQUEST_FAILURE,
    ]),
    profile: isFetchingReducer([
      t.PROFILE_REQUEST,
      t.PROFILE_REQUEST_SUCCESS,
      t.PROFILE_REQUEST_FAILURE,
    ]),
    createOrder: isFetchingReducer([
      t.CREATE_ORDER_REQUEST,
      t.CREATE_ORDER_SUCCESS,
      t.CREATE_ORDER_FAILURE,
    ]),
    createSource: isFetchingReducer([
      t.CREATE_STRIPE_SOURCE_REQUEST,
      t.CREATE_STRIPE_SOURCE_SUCCESS,
      t.CREATE_STRIPE_SOURCE_FAILURE,
    ]),
    payOrder: isFetchingReducer([
      t.PAY_ORDER_REQUEST,
      t.PAY_ORDER_SUCCESS,
      t.PAY_ORDER_FAILURE,
    ]),
    fetchOrder: isFetchingReducer([
      t.ORDER_STATUS_REQUEST,
      t.ORDER_STATUS_SUCCESS,
      t.ORDER_STATUS_FAILURE,
    ]),
    cartItems: keyedFetchReducer({
      types: [
        t.UPDATE_CART_ITEM_REQUEST,
        t.UPDATE_CART_ITEM_SUCCESS,
        t.UPDATE_CART_ITEM_FAILURE,
      ],
      mapActionToKey: ({ articleID }) => articleID,
    }),
  }),

  data: combineReducers({
    user,
    profile,
    cart,
    order,
    ui,
  }),
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer/index.js